export default __webpack_public_path__ + "static/media/trust-wallet.8f8456cf.svg";